import { render, staticRenderFns } from "./Youtube.vue?vue&type=template&id=193acfda&scoped=true"
import script from "./Youtube.vue?vue&type=script&lang=js"
export * from "./Youtube.vue?vue&type=script&lang=js"
import style0 from "./Youtube.vue?vue&type=style&index=0&id=193acfda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193acfda",
  null
  
)

export default component.exports